import { v4 as uuidv4 } from 'uuid';

/**
 * Every item involved in one combine gesture (drag-to-superset, or a
 * multi-select via the superset picker) shares ONE batchId - the contract
 * node-server needs to treat the whole gesture (a SWAP call, a plain
 * ASSIGNMENT_UPDATE call, and the reorder chasing them, across however many
 * assignedIds are involved) as a single undoable action, the same way
 * `persistSupersetGrouping` already does for the month-view bulk-select path.
 *
 * As of node-server commit 2b64b5950, the dedup-by-batchId check this
 * depends on (updateProgrammedItemInjected, service.js ~3514-3521) appears to
 * compare target_id/target_type backwards relative to how
 * buildCalendarActionBody writes them, so it doesn't actually scope by
 * assignedId the way the contract needs - flagged back to the backend team.
 * The frontend sends the shared batchId regardless, since that's what the
 * real fix needs to see. See
 * test/unit/services/calendarProgramming.spec.js:4942 in node-server for the
 * original data-loss proof this contract depends on the backend fixing
 * correctly (i.e. scoped by assignedId, not just by calendar/athlete).
 *
 * @param {Object[]} participantItems - the items involved in this one combine
 *   gesture (e.g. [sourceItem, targetItem], or [targetItem, ...sourceItems])
 * @returns {string | undefined} undefined when there's nothing to share with
 *   (fewer than 2 participants) - the caller's own currentBatchId/uuidv4
 *   fallback applies as usual in that case.
 */
const getCombineSharedBatchId = (participantItems) => (
  participantItems.length >= 2 ? uuidv4() : undefined
);

export default getCombineSharedBatchId;
